<template>
    <div class="animated">
        <form @submit.prevent="onSubmit" role="form">
            <b-field
                :label="$t('Email')"
                :type="form.errors.has('email') ? 'is-danger' : null"
                :message="form.errors.get('email')"
            >
                <b-input
                    v-model="form.email"
                    type="email"
                    :placeholder="$t('Email')"
                    icon="email-outline"
                    name="email"
                    required
                    autofocus
                    size="is-medium"
                />
            </b-field>

            <div class="field">
                <p class="control">
                    <button type="submit" class="button is-primary is-medium is-fullwidth">
                        {{ $t('Send password reset Link') }}
                    </button>
                </p>
            </div>

            <p class="has-text-centered">
                <router-link :to="{ name: 'login' }">
                    {{ $t('Back to login') }}
                </router-link>
            </p>
        </form>
    </div>
</template>

<script>
let fields = {};

export default {
    data() {
        // Init fields
        fields = {
            email: ''
        };

        return {
            form: new Form(fields)
        };
    },

    mounted() {
        document.title = i18n.t('Lost password') + ` | ${AppTitle}`;
    },

    methods: {
        onSubmit() {
            this.form
                .post('/lost-password/email')
                .then(() => {
                    this.$router.push({ name: 'login', query: { message: 'reset-link-sent' } });
                })
                .catch(() => {});
        }
    }
};
</script>
